module.exports = __webpack_public_path__ + "media/v2/warehouse-efa1497d.png";